
<script setup lang="ts">
// Props で親要素の種類を受け取る
const props = defineProps<{
  type?: string
}>()

type Link = {
  href: string;
  text: string;
  suffix?: string;
  isInternal?: boolean;
}

// devまたはstgしかテスト環境がないものはsuffixで区別
const links = ref<Link[]>([
  { href: 'https://www.bang.co.jp/', text: '自動車保険' },
  { href: 'https://www.bang.co.jp/hojin/', text: '自動車保険（法人）', suffix: 'dev' },
  { href: 'https://www.bang.co.jp/bike/', text: 'バイク保険', suffix: 'dev' },
  { href: 'https://www.bang.co.jp/bicycle/', text: '自転車保険', suffix: 'dev'},
  { href: 'https://life.bang.co.jp/', text: '生命保険', suffix: 'dev' },
  { href: '/', text: '火災保険', isInternal: true },
  { href: 'https://www.bang.co.jp/travel/', text: '旅行保険' },
  { href: 'https://www.bang.co.jp/golf/', text: 'ゴルフ保険' } 
])

const getEnvironmentUrl = (link: Link): string => {
  const urlObj = new URL(link.href);

  const changeUrl = (suffix: string): string => {
    urlObj.hostname = urlObj.hostname
    .replace('www.', 'www' + suffix + '.')
    .replace('life.', 'life' + suffix + '.');
    return urlObj.hostname;
  }

  if (typeof window !== 'undefined') {
    const currentHostname = window.location.hostname;
    switch (true) {
      // 現在のホスト名に-devまたはå-stgが含まれている場合、それに応じてリンクを変更
      // どちらも含まれていない場合は本番環境orローカルとみなす(本番に飛ばす)
      // devとstgのどちらか一方しかない場合、suffixに応じて切り替え
      case currentHostname.includes('-dev'):
        if (link.suffix === 'stg') {
          changeUrl('-stg')
          break;
        }else{
          changeUrl('-dev')
        }
        break;
      case currentHostname.includes('-stg'):
        if (link.suffix === 'dev') {
          changeUrl('-dev')
          break;
        }else{
          changeUrl('-stg')
        }
        break;
      default:
        break;
    }
  }

  return urlObj.toString();
}

onMounted(() => {
  // 外部リンクのみ環境に応じてURLを書き換え
  for (let i = 0; i < links.value.length; i++) {
    const link = links.value[i]
    if (!link.isInternal) {
      link.href = getEnvironmentUrl(link)
    }
  }
})
</script>

<template>
<ul :class="{ 'footer-otherLink-ul': props.type === 'footer', 'header-otherLink-ul': props.type === 'header' }">
  <li v-for="link in links" :key="link.text">
    <a
      :href="link.href"
      :target="link.isInternal ? '_self' : '_blank'"
      :rel="link.isInternal ? '' : 'noopener'"
    >{{ link.text }}</a>
  </li>
</ul>
</template>
<style lang="scss" scoped>
@include media(pc) {
  ul {
    overflow: hidden;
    line-height: 1;
    letter-spacing: -0.4em;
  }

  li {
    display: inline-block;
    color: #ccc;
    letter-spacing: 0;
    // 最後以外にセパレーターを追加
    &:not(:last-child)::after {
      content: '｜';
      color: #ccc;
    }
    a{
      color: #333;
      font-size: px(12);
      vertical-align: top;
      text-decoration: none;
    }
  }
  .footer-otherLink-ul{
      margin: 0 auto;
      padding: 14px 0 0;
      overflow: hidden;
      line-height: 0.8em;
      letter-spacing: -0.4em;

    li {
      display: inline-block;
      letter-spacing: 0;
      &:not(:last-child)::after {
        content: '｜';
        color: #333;
      }

      a {
        color: #333;
        font-size: px(12.9);
      }
    }
  }
}
</style>